export default "__VITE_ASSET__65518660__"